import { Button, TextField, WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { IVarHomepageSearchDTO } from '../../repository/jago/model/input/IVarHomepageSearchDTO';
import ReduxLanguage from '../ReduxLanguage';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
    alignItems:'center',
  },
  logo: {
    margin: 5,
    marginBottom: 15,
    alignSelf: 'center',
    height: 45,
  },
  text: {
    margin: 0,
    marginBottom: 0,
  },
  innerHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
    marginLeft: 10,
  },
  title: {
    color: 'white',
  },
  circularProgress: {
    color: 'white',
  },
});


export interface IActivationStatusOption {
  label: string;
  value: string;
  original: string;
}
export interface IActivationClusterOption {
  label: string;
  value: string;
}

export interface IVarHomepageSearchBarProps extends WithStyles<typeof styles> {
  onSearch: (searchValues: IVarHomepageSearchDTO) => void;
  onResetSearch: () => void;
  totalElements: string | number;
  onCreateNewEntityButtonClick: () => void;
}

export interface IVarHomepageSearchBarState {
  searchValues: Record<keyof IVarHomepageSearchDTO, string>;
}

class VarHomepageSearchBar extends React.Component<IVarHomepageSearchBarProps, IVarHomepageSearchBarState> {

  constructor(props: IVarHomepageSearchBarProps) {
    super(props);
    this.state = {
      searchValues: {
        name: ""
      }
    }
  }

  public onSetSearchValue(field: keyof IVarHomepageSearchDTO, value: string) {
    const { searchValues } = this.state;
    searchValues[field] = value;
    this.setState({ searchValues });
    this.onSearch()
  }

  public onSearch() {
    const { onSearch } = this.props;
    onSearch(this.state.searchValues);
  }

  public onResetFields() {
    const { onResetSearch } = this.props;
    this.setState({
        searchValues:{
          name: ""
        }
    });
    onResetSearch();
  }

  public render() {
    const { classes, onCreateNewEntityButtonClick, totalElements } = this.props;
    const { searchValues } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.innerHeader}>
          <h3 className={classes.text} style={{ fontWeight: 'bold' }}>
            <ReduxLanguage languageKey='vars.plantThemes' />
          </h3>
          <h3 className={classes.text} style={{ marginLeft: 10, fontWeight: 'bold' }}>({totalElements})</h3>
        </div>
        <TextField
          id="outlined-basic"
          label={<ReduxLanguage languageKey="forms.search" /> }
          variant="outlined"
          type="search"
          style={{marginLeft: 10, marginRight: 10}}
          value={searchValues.name}
          onChange={e => this.onSetSearchValue('name', e.target.value)}
        />
        <span style={{flexGrow:'1'}}></span>
        <Button
          variant="contained"
          style={{ backgroundColor: '#5AC0B1', color: 'white', marginRight: 20, fontWeight: 'bold'  }}
          onClick={() => onCreateNewEntityButtonClick()}
        >
          <ReduxLanguage languageKey="forms.add" />
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(VarHomepageSearchBar);
